import Page from "../../Components/Page";


export default function Money() {
    return (
        <Page title="Money" grid fullHeight>
        </Page>
    );
}
